import { render } from "./FormLogin.vue?vue&type=template&id=639ea258&scoped=true"
import script from "./FormLogin.vue?vue&type=script&lang=js"
export * from "./FormLogin.vue?vue&type=script&lang=js"

import "./FormLogin.vue?vue&type=style&index=0&id=639ea258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639ea258"]])

export default __exports__